/**
 * Where to go from here. Every setup screen ends with one of these, so a
 * person who has just saved or confirmed is never left looking at a form
 * wondering what comes next: the next thing still to do, or -- when
 * nothing is -- the matches. The dashboard's checklist is the same list;
 * this is the step of it that applies right here.
 */

export interface NextStepInfo {
  /** The dashboard view to open. */
  go: string;
  label: string;
  hint: string;
}

export function NextStep({ ready, next, onGo, onBack, doneWords }: {
  /** This screen's own step is complete (confirmed, saved). */
  ready: boolean;
  next: NextStepInfo;
  onGo: (go: string) => void;
  onBack: () => void;
  /** What "done" means here, in one clause: "Answers confirmed". */
  doneWords: string;
}) {
  return (
    <div className={`next-step ${ready ? "ready" : ""}`}>
      {ready ? (
        <>
          <p className="next-step-done"><span className="next-step-mark" aria-hidden="true">✓</span> {doneWords}.</p>
          <p className="next-step-label">Next: {next.label}</p>
          <p className="muted small">{next.hint}</p>
          <div className="row">
            <button className="btn" onClick={() => onGo(next.go)}>{next.label} →</button>
            <button className="btn ghost" onClick={onBack}>Back to dashboard</button>
          </div>
        </>
      ) : (
        <p className="muted small">When you're done here: <button className="step-link small" onClick={() => onGo(next.go)}>{next.label}</button>. Or <button className="step-link small" onClick={onBack}>back to the dashboard</button>.</p>
      )}
    </div>
  );
}
